class upCircle {
  constructor() {
    this.upCircleButton = document.querySelector(".up-circle");
    this.events();
  }

  events() {
    if (this.upCircleButton) {
      window.addEventListener("scroll", () => this.myScrollFunc());
      this.upCircleButton.addEventListener("click", () => this.scrollTop());
    }
  }

  myScrollFunc() {
    let y = window.scrollY;
    if (y >= 800) {
      this.upCircleButton.className = "up-circle show";
    } else {
      this.upCircleButton.className = "up-circle";
    }
  }

  scrollTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}

export default upCircle;
